import React from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  feature: string;
  message?: string;
  onDismiss?: () => void;
  inline?: boolean; // render inline (no overlay)
}

const FEATURE_LABELS: Record<string, string> = {
  email_sync:      "Automatic Email Sync",
  ai_assistant:    "AI Job Assistant",
  batch_apply:     "Batch Apply",
  community:       "Community Access",
  ai_credits:      "AI Features",
  search:          "Advanced Search",
  resume_store:    "Extra Resume Storage",
};

const UpgradePrompt: React.FC<Props> = ({ feature, message, onDismiss, inline = false }) => {
  const navigate = useNavigate();
  const featureLabel = FEATURE_LABELS[feature] || feature;

  const content = (
    <div className="upgrade-prompt">
      <div className="upgrade-prompt__icon">🚀</div>
      <h3 className="upgrade-prompt__title">Upgrade to Pro</h3>
      <p className="upgrade-prompt__body">
        {message || `${featureLabel} is available on the Pro plan.`}
      </p>
      <div className="upgrade-prompt__actions">
        <button
          className="upgrade-prompt__cta"
          onClick={() => navigate("/subscription")}
        >
          View Plans
        </button>
        {onDismiss && (
          <button className="upgrade-prompt__dismiss" onClick={onDismiss}>
            Maybe later
          </button>
        )}
      </div>
    </div>
  );

  if (inline) return content;

  return (
    <div className="upgrade-prompt__overlay" onClick={onDismiss}>
      <div onClick={e => e.stopPropagation()}>{content}</div>
    </div>
  );
};

export default UpgradePrompt;
